import React, { useState, useEffect, useRef } from "react";

export const Counter = ({ end, duration = 1500, suffix = "" }) => {
  const [count, setCount] = useState(0);
  const elementRef = useRef(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    const currentRef = elementRef.current;
    if (!currentRef) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          startCountUp();
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(currentRef);

    const startCountUp = () => {
      let startTime = null;
      const endVal = parseInt(end, 10);
      if (isNaN(endVal)) return;

      const animate = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const progress = timestamp - startTime;
        const percentage = Math.min(progress / duration, 1);
        
        // Easing out quadratic
        const easeProgress = percentage * (2 - percentage);
        const currentCount = Math.floor(easeProgress * endVal);
        
        setCount(currentCount);

        if (progress < duration) {
          requestAnimationFrame(animate);
        } else {
          setCount(endVal);
        }
      };

      requestAnimationFrame(animate);
    };

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [end, duration]);

  return (
    <span ref={elementRef} className="stat-number">
      {count}{suffix}
    </span>
  );
};
